@if (textData()) {
  <markdown appImageZoom>{{ textData() }}</markdown>
}

@if (htmlData()) {
  <div appImageZoom [innerHTML]="htmlData()" (click)="handleClick($event)" (keydown)="handleClick($event)" tabindex="0" role="region"></div>
}

@if (!textData() && !htmlData()) {
  <p class="mt-8 text-center text-sm text-gray-500">{{ 'global.noOEDataFound' | transloco }}</p>
}
